import { useCallback } from 'react'
import { useAppState } from '@/contexts/AppStateContext'

/**
 * 交易时刷新状态的 hook
 * 用于在交易完成后刷新用户信息和卡片信息
 */
const useTransactionRefresh = () => {
  const { actions } = useAppState()

  // 交易完成后刷新所有状态
  const refreshAfterTransaction = useCallback(async () => {
    try {
      await actions.refreshAll()
    } catch (error) {
      console.error('交易后刷新状态失败:', error)
    }
  }, [actions])

  // 只刷新用户信息（如余额变化）
  const refreshUserInfoAfterTransaction = useCallback(async () => {
    try {
      await actions.refreshUserInfo()
    } catch (error) {
      console.error('交易后刷新用户信息失败:', error)
    }
  }, [actions])

  // 只刷新卡片信息（如卡片状态变化）
  const refreshCardInfoAfterTransaction = useCallback(async () => {
    try {
      // 同时刷新虚拟卡和实体卡信息
      await Promise.all([
        actions.refreshCardList(),
        actions.refreshMerchantConfig()
      ])
    } catch (error) {
      console.error('交易后刷新卡片信息失败:', error)
    }
  }, [actions])

  return {
    refreshAfterTransaction,
    refreshUserInfoAfterTransaction,
    refreshCardInfoAfterTransaction
  }
}

export default useTransactionRefresh